import z from "zod";

import avatarMissingImage from "@/assets/images/placeholders/avatar-missing.png";

const avatarMissing = avatarMissingImage;

const carouselAccountSchema = z
  .object({
    account_id: z.string(),
    account_avatar: z.string().catch(avatarMissing),
    acct: z.string(),
    id: z.string().catch(""),
    seen: z.boolean(),
  })
  .transform((carouselAccount) => {
    carouselAccount.id = carouselAccount.account_id;

    return carouselAccount;
  });

type CarouselAccount = z.infer<typeof carouselAccountSchema>;

export { carouselAccountSchema, type CarouselAccount };
